
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"highlight-stroke",attrs:{"fill":"none","stroke":"#fff","stroke-linejoin":"round","d":"M0 13.8h3.7V8.5h4v6.3h2.6v-4.6H12v1.6h2.2v4.8h1.1V8h.8V6.4h2V8h.7v5.8h1.5V9.6h1.9v3.1H25"}})])
          )
        }
      }
    